<template>
  <div>
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Permission Setting</li>
    </vs-breadcrumb>

    <!-- <b-breadcrumb style="background-color: #ffffff;">
      <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
      <b-breadcrumb-item active><h5>Permission Setting</h5></b-breadcrumb-item>
    </b-breadcrumb> -->
    <div slot="header">
      <vs-row>
        <h3 class="ml-2 headerText">&nbsp;&nbsp;Permission Setting</h3> </vs-row
      ><br />
    </div>
    <vs-row>
      <vs-col vs-xs="12" vs-lg="5">
        <vs-card style="border-radius: 20px">
          <vs-row style="display: flex; align-items: center">
            <h4 class="mt-2">Roles</h4>
            <vs-spacer />
            <h6>
              <vs-button
                color="success"
                style="border-radius: 20px"
                size="sm"
                icon="add"
                @click="swap = 3"
                type="filled"
                >Add New Role</vs-button
              >
            </h6>
            <!-- <vs-button color="#007bff" type="line" icon="add" @click="swap = 3"
              >Add New Role</vs-button
            >  --> </vs-row
          ><br />

          <b-list-group
            v-for="item in rolelist"
            :key="item.id"
            style="padding: 3px"
          >
            <b-list-group-item
              button
              @click="edit(item)"
              style="padding: 1px; border-color: #ffffff"
            >
              <vs-row
                style="display: flex; align-items: center; margin-left: 4px"
              >
                <h6>
                  {{ item.name }}
                  <!-- <a href="#">{{item.name}}</a>  -->
                </h6>
                <vs-spacer />
                <vs-tooltip text="Copy" position="top">
                  <vs-button
                    class="text-dark"
                    color="dark"
                    type="flat"
                    icon="content_copy"
                    :disabled="true"
                  ></vs-button
                ></vs-tooltip>
                <vs-tooltip text="Delete" position="top">
                  <!-- <vs-button color="danger"  type="flat" icon="delete"   @click="del(item)"></vs-button></vs-tooltip> -->
                  <vs-button
                    color="danger"
                    type="flat"
                    icon="delete"
                    v-b-modal.modal-center
                    @click="btndelper = item"
                  ></vs-button
                ></vs-tooltip>
              </vs-row>
            </b-list-group-item>
          </b-list-group>

          <b-modal id="modal-center" centered>
            <template #modal-title>
              <b class="text-danger">
                <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
                Role</b
              >
            </template>
            <p class="my-4">Do you want to delete role?</p>

            <template #modal-footer="{ cancel }">
              <!-- Button with custom close trigger value -->
              <b-button id="btncancel" variant="light" @click="cancel()">
                Cancel
              </b-button>
              <vs-button
                color="danger"
                style="border-radius: 20px"
                size="sm"
                @click="del()"
                type="filled"
                >Delete</vs-button
              >
            </template>
          </b-modal>
        </vs-card>
      </vs-col>

      <!--card  Role-->
      <vs-col vs-xs="12" vs-lg="7">
        <vs-card style="border-radius: 20px" v-if="!swap">
          <h4 class="mt-2">Role Details</h4>
          <br />
          <vs-row style="align-items: center">
            <vs-input
              icon-no-border
              icon="account_circle"
              label-placeholder="Role name"
              v-model="editrole.name"
            />
            <vs-spacer />
            <vs-button
              color="success"
              type="flat"
              icon="done"
              @click="selectall()"
              >Select All Permission</vs-button
            >
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="clearall()"
              >Clear All Permission</vs-button
            > </vs-row
          ><br />

          <div :key="index" v-for="(item2, index) in title">
            <h6><b></b></h6>
            <table id="customers">
              <tr>
                <th style="width: 5%">
                  <span>
                    <vs-icon
                      :icon="icon[index]"
                      size="20px"
                      color="#28a745"
                    ></vs-icon>
                  </span>
                </th>
                <th style="font-size: 14px; color: #28a745">{{ item2 }}</th>
              </tr>
              <tr
                :key="index"
                :value="item.name"
                v-for="(item, index) in permlist"
              >
                <td v-if="item.type == item2">
                  <b-form-checkbox
                    style="cursor: pointer"
                    v-model="selected"
                    :value="item.name"
                  ></b-form-checkbox>
                </td>
                <td v-if="item.type == item2">{{ item.name }}</td>
              </tr>
              <br />
            </table>
          </div>

          <!-- 
          <div :key="index" v-for="(item2,index) in title ">
            <h6 ><b>{{item2}}</b> </h6>
            
                 <b-list-group  :key="index" :value="item.name" v-for="(item,index) in permlist">
                     <b-list-group-item v-if="item.type==item2"  button> <b-form-checkbox v-model="selected" :value="item.name">
                        {{ item.name }}</b-form-checkbox>
                    </b-list-group-item>
                  </b-list-group><br>

          </div> -->

          <!-- <br>
  <b-list-group :key="index" :value="item.name" v-for="(item,index) in permlist">
  <b-list-group-item  button> <b-form-checkbox
     
        v-model="selected"
        :value="item.name"
       
      >{{ item.name }} </b-form-checkbox></b-list-group-item>
  
</b-list-group> -->
          <vs-row class="mb-2">
            <vs-button
              class="bts"
              color="success"
              @click="editroleaccept"
              type="filled"
              >Save</vs-button
            >
            <vs-button class="ml-2" color="dark" @click="reload()" type="flat"
              >Cancel</vs-button
            >
          </vs-row>
        </vs-card>

        <!--card Permission List-->
        <vs-card style="border-radius: 20px" v-if="swap == 1">
          <h5 class="mt-2">Permission List</h5>
          <br />
          <vs-table
            :data="permlist"
            :max-items="descriptionItems[0]"
            search
            hoverFlat="false"
            multiple
            v-model="selected"
            :description-items="descriptionItems"
            style="background-color: #f2f3f4; border-radius: 20px"
          >
            <template slot="header">
              <div
                style="
                  margin-left: 1%;
                  width: auto;
                  margin-top: 1%;
                  margin-bottom: 1%;
                  border-radius: 5px;
                "
              >
                <vs-dropdown>
                  <h6 class="a-icon" href.prevent>
                    Filters :
                    {{ this.filtered }}
                    <vs-icon class size="12px" icon="expand_more"></vs-icon>
                  </h6>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-for="(item, i) in filterlist"
                      :key="i"
                      @click="actionchange(item)"
                    >
                      {{ item }}</vs-dropdown-item
                    >
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              &nbsp;&nbsp;
            </template>
            <template slot="thead">
              <vs-th class="th" sort-key="type"
                ><span><vs-icon icon="unfold_more" size="16px"></vs-icon></span
                >Type</vs-th
              >
              <vs-th class="th" sort-key="name"
                ><span><vs-icon icon="unfold_more" size="16px"></vs-icon></span
                >Name</vs-th
              >
              <vs-th class="th" sort-key="detail"
                ><span><vs-icon icon="unfold_more" size="16px"></vs-icon></span
                >Detail</vs-th
              >
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                :key="indextr"
                v-for="(tr, indextr) in data"
                :state="data[indextr].state"
              >
                <vs-td :data="data[indextr].type">
                  {{ data[indextr].type }}
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>
                <vs-td :data="data[indextr].detail">
                  {{ data[indextr].detail }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-card>

        <!--card Add New Role-->
        <vs-card style="border-radius: 20px" v-if="swap == 3">
          <h4 class="mt-2">Add New Role</h4>
          <br />
          <vs-row style="align-items: center">
            <vs-input
              icon-no-border
              icon="account_circle"
              label-placeholder="Role name"
              v-model="newrole.name"
            />
            <vs-spacer />
            <vs-button
              color="success"
              type="flat"
              icon="done"
              @click="selectall()"
              >Select All Permission</vs-button
            >
            <vs-button
              color="danger"
              type="flat"
              icon="clear"
              @click="clearall()"
              >Clear All Permission</vs-button
            > </vs-row
          ><br />

          <div :key="index" v-for="(item2, index) in title">
            <h6><b></b></h6>
            <table id="customers">
              <tr>
                <th style="width: 5%">
                  <span>
                    <vs-icon
                      :icon="icon[index]"
                      size="20px"
                      color="#28a745"
                    ></vs-icon>
                  </span>
                </th>
                <th style="font-size: 14px; color: #28a745">{{ item2 }}</th>
              </tr>
              <tr
                :key="index"
                :value="item.name"
                v-for="(item, index) in permlist"
              >
                <td v-if="item.type == item2">
                  <b-form-checkbox
                    style="cursor: pointer"
                    v-model="selected"
                    :value="item.name"
                  ></b-form-checkbox>
                </td>
                <td v-if="item.type == item2">{{ item.name }}</td>
              </tr>
              <br />
            </table>
          </div>
          <br />
          <vs-row class="mb-2">
            <vs-button
              class="bts"
              color="success"
              @click="newroleaccept"
              type="filled"
              >Save</vs-button
            >
            <vs-button class="ml-2" color="dark" @click="reload()" type="flat"
              >Cancel</vs-button
            >
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-prompt
      color="primary"
      @accept="newroleaccept"
      @cancel="(newrole.name = ''), (selected = [])"
      title="New Role"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt">
        Role name<vs-input
          style="width: auto"
          color="#333f50"
          v-model="newrole.name"
        />
        <br />
        <vs-select
          style="width: auto"
          multiple
          autocomplete
          class="selectExample"
          label="Select Permission"
          v-model="selected"
        >
          <vs-select-item
            :key="index"
            :value="item.name"
            :text="item.name"
            v-for="(item, index) in permlist"
          /> </vs-select
        ><br />
        <vs-button type="filled" @click="selectall()"
          >Select All Permission</vs-button
        >
        <vs-button type="filled" @click="clearall()" class="ml-4"
          >Clear All Permission</vs-button
        ><br /><br />
        <vs-alert color="primary" icon="new_releases">
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
export default {
  name: "Permission",
  components: {},
  data: () => ({
    id: "",
    swap: true,
    btndelper: "",
    title: [
      "Open task",
      "Completed task",
      "Dashboard",
      "WO Form",
      "Asset",
      "User",
      "Alert",
      "Device",
      "Gateway",
      "Overview",
      "Location setting",
    ],
    icon: [
      "report_problem",
      "assignment_turned_in",
      "dashboard",
      "description",
      "web_asset",
      "supervisor_account",
      "notification_important",
      "book_online",
      "router",
      "layers",
      "location_on",
    ],
    selected: [],
    options1: [],
    items: [
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
      {
        heading1: "table cell",
        heading2: "table cell",
        heading3: "table cell",
      },
    ],
    newrole: { name: "" },
    editrole: { name: "" },
    activePrompt: false,
    activePrompt2: false,
    rolelist: [],
    calldata: [],
    permlist: [],
    temp: [],
    descriptionItems: [5, 10, 15],
    filtered: "",
    filterlist: [
      "All",
      "Open task",
      "Completed task",
      "Work Request",
      "Dashboard",
      "Template",
      "Asset",
      "User",
    ],
  }),
  methods: {
    edit(item) {
      this.id = item.id;
      this.editrole.name = item.name;
      this.selected = item.permlist;
      this.activePrompt2 = true;
      this.swap = false;
    },
    del() {
      this.$API
        .post("updaterole", {
          id: this.btndelper.id,
          isdelete: true,
        })
        .then(() => {
          location.reload();
        });
    },
    reload() {
      this.swap = true;
    },

    newroleaccept() {
      this.$API
        .post("role", {
          name: this.newrole.name,
          perm: this.selected,
          token: this.$session.get("token"),
        })
        .then(() => {
          location.reload();
        });
    },
    editroleaccept() {
      this.$API
        .post("updaterole", {
          id: this.id,
          name: this.editrole.name,
          perm: this.selected,
          isdelete: false,
        })
        .then(() => {
          location.reload();
        });
    },
    selectall() {
      this.permlist.forEach((element) => {
        this.selected.push(element.name);
      });
    },
    clearall() {
      this.selected = [];
    },
    actionchange(name) {
      if (name == "All") {
        this.permlist = this.calldata;
      } else {
        this.permlist = this.calldata;
        this.permlist.forEach((element) => {
          if (element.type == name) {
            this.temp.push(element);
          }
        });
        this.permlist = this.temp;
        this.temp = [];
      }
    },
  },
  mounted() {
    this.$API
      .get("role/user")
      .then((result) => {
        this.rolelist = result.data;
      });
    this.$API.get("permlist").then((result) => {
      this.permlist = result.data;
      this.calldata = result.data;
    });
  },
};
</script>

<style scoped>
.th {
  padding-left: 0%;
}
.bts {
  width: 70px;
  border-radius: 18px;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
/* .con-select >>> .input-select-con {
  width: ;
} */
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0%;
  border-bottom-left-radius: 0%;
}

.list-group-item:first-child {
  border-top-left-radius: 0%;
  border-top-right-radius: 0%;
}
div.ex3 {
  height: 350px;
  overflow-y: auto;
}
#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
  cursor: pointer;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
</style>
